import React, { useState, useEffect, memo } from 'react';
import { IonButton, IonRow, IonCol } from '@ionic/react';
import '../../../pages/Search/New/NewPage.scss';
import { declineReasonCodesVisibility } from 'app/utils/sourceTMSAndDivisionFilter';
import { DECLINE_REASON_CODE_MESSAGE } from 'app/utils/constants';
import { declineReasonCodes } from '../../../utils/mock_Data';

interface DropDownProps {
  sourceTMS: string;
  division: string;
  labelName: string;
  declineReason: string;
  payloadReasonCode: string;
  handleChange: any;
}
export const DeclineDropDown: React.FC<DropDownProps> = memo((props: any) => {
  const { declineReason, payloadReasonCode, handleChange } = props;
  const [showOptions, setShowOptions] = useState(false);
  const [clickedOption, setclickedOption] = useState({ name: payloadReasonCode, value: declineReason });
  const [selectedOption, setselectedOption] = useState({ name: payloadReasonCode, value: declineReason });
  const declineReasonCodeItemList = declineReasonCodesVisibility(props?.sourceTMS,props?.division) || declineReasonCodes;

  const onConfrim = (option: any) => {
    setselectedOption(option);
    setShowOptions(false);
    const event = { target: { name: option.name, value: option.value } };
    handleChange(event);
  };

  useEffect(() => {
    setclickedOption({ name: payloadReasonCode, value: declineReason });
    setselectedOption({ name: payloadReasonCode, value: declineReason });
  }, [declineReason]);

  return (
    <>
      <div className="dropdown-container">
        <div>
          <IonButton
            type="button"
            class="dropdown-button"
            data-test="dropdown-click"
            onClick={() => setShowOptions(showOptions ? false : true)}>
            <span className={`${selectedOption.value ? 'button-content' : 'placeholder' }`}>{selectedOption.value || DECLINE_REASON_CODE_MESSAGE}</span>
            <i className="down"></i>
          </IonButton>
        </div>

        {showOptions ? (
          <div className="dropdown-list">
            {declineReasonCodeItemList?.map((option: any, k: any) => (
              <IonRow key={k} onClick={() => onConfrim(option)}>
                <IonCol className={option.name === clickedOption.name ? 'checked' : ''}>
                  {option.value}
                </IonCol>
              </IonRow>
            ))}
          </div>
        ) : null}
      </div>
    </>
  );
});
